export default {
  strict: true,
  namespaced: true,
  state: {
    actionLogs: []
  },
  mutations: {
    resetActionLogs (state) {
      state.actionLogs = []
    },
    setAction (state, value) {
      state.actionLogs = value
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/action-logs.js